import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { LandingPageVM } from './viewModel';

export const useSectionVM = ({
  vm,
  sectionId: sid,
}: {
  sectionId: string;
  vm: LandingPageVM;
}) => {
  const defaultValues =
    vm.formsMap[sid]?.getValues() || (vm.getSection(sid) as any);

  const newForm = useForm({
    resolver: zodResolver(vm.getSectionSchema(sid)),
    mode: 'onBlur',
    defaultValues,
  });

  useEffect(() => {
    if (!vm.formsMap[sid]) {
      vm.addForm(sid, newForm);
      console.log('addForm for section', sid, newForm);
    }
    return () => null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid]);
  const form = vm.formsMap[sid] || newForm;
  return {
    form,
    section: vm.getSection(sid),
    isDirty: () => vm.isDirty(sid),
    hasErrors: () => vm.hasErrors(sid),
    validate: () => vm.validateSection(sid),
    save: vm.saveAll,
  };
};
